import * as pc from "playcanvas";
import { ColliderNode } from "@animech/supermodel";
import { Property } from "../../definitions";

export type PropertyValueGetter = (property: Property) => unknown;
export type PropertyValueConverter = (propertyValue: unknown) => pc.Mat4 | null;

export type DynamicColliderNodes = (
	propertyValueGetter: PropertyValueGetter,
) => ColliderNode[];

export type DynamicColliderNodeDefinition = {
	shape: ColliderNode["shape"];
	property: Property;
	propertyConverter: PropertyValueConverter;
};

export type DynamicColliderNodeDefinitionsByModel = Record<
	string,
	DynamicColliderNodeDefinition[]
>;

// Map between 3D models and the properties that should drive their collider
export const dynamicColliderNodeDefinitionsByModel: () => DynamicColliderNodeDefinitionsByModel =
	() => {
		return {};
	};

export function createDynamicColliderNodes(
	propertyValueGetter: PropertyValueGetter,
	dynamicColliderNodesDefinitions: DynamicColliderNodeDefinition[],
): ColliderNode[] {
	return dynamicColliderNodesDefinitions.reduce<ColliderNode[]>(
		(result, dynamicColliderNodeDefinition, index) => {
			const propertyValue = propertyValueGetter(
				dynamicColliderNodeDefinition.property,
			);
			const transform =
				dynamicColliderNodeDefinition.propertyConverter(propertyValue);

			if (!transform) {
				console.warn("Failed to parse dynamic collider transform");

				return result;
			}

			result.push({
				shape: dynamicColliderNodeDefinition.shape,
				serialNumber: String(index),
				transform,
			});

			return result;
		},
		[],
	);
}
